import { Check, Warning, Hash } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { isValidTurkishVkn } from "./utils";
import type { OnboardingLabels } from "./types";

export interface TaxIdChecksumBadgeProps {
  value: string;
  countryCode?: string;
  labels: OnboardingLabels["taxIdBadge"];
  className?: string;
}

export function TaxIdChecksumBadge({ value, countryCode = "TR", labels, className }: TaxIdChecksumBadgeProps) {
  const trimmed = (value || "").replace(/\D/g, "");
  let state: "idle" | "valid" | "invalid" = "idle";

  if (trimmed.length === 0) state = "idle";
  else if (countryCode !== "TR") state = trimmed.length >= 6 ? "valid" : "idle";
  else state = trimmed.length === 10 && isValidTurkishVkn(trimmed) ? "valid" : trimmed.length >= 10 ? "invalid" : "idle";

  const config = {
    idle: { icon: Hash, tone: "bg-biz-muted text-biz-foreground-muted", label: labels.idle },
    valid: { icon: Check, tone: "bg-biz-success/10 text-biz-success", label: labels.valid },
    invalid: { icon: Warning, tone: "bg-biz-danger/10 text-biz-danger", label: labels.invalid },
  }[state];

  const Icon = config.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium transition-colors",
        config.tone,
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Icon size={14} aria-hidden />
      <span>{config.label}</span>
    </span>
  );
}
